module.exports = __webpack_public_path__ + "img/homePIc2.83f75e3d.png";